import { WebhooksApiClient } from '@fourthwall/services/dist/WebhooksApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useWebhookConfigurationsQuery = createQueryHook(
  WebhooksApiClient.getWebhookConfigurations,
  {
    queryKey: ['webhookConfigurations'],
  },
)
